/**=========================================================
 * Module: login.js
 * Login Controller
 =========================================================*/

App.controller('LoginController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R) {
    "use strict";
    
    $scope.model = {
        username: '',
        password: '',
        remember: true
    };
    
    $scope.app = $rootScope.app;
    
    $scope.noLogin = false;
    $scope.submitting = false;
    $scope.loginError = '';
    $scope.attempts = -1;

    $scope.login = function(){
        if($scope.model.username && $scope.model.password){
            $scope.submitting = true;
            if($scope.add){
                $scope.model.action = 'ConnectSession'

            }
            R.all('session').post($scope.model).then(
                function(session){
                    //if(window.location.host.indexOf('localhost:5500')>=0){
                    //    window.localStorage.setItem('session', session.id)
                    //}
                    if(session.account){
                        FIREBASE.auth(session.jwt, function(){
                            $scope.attempts = -1;
                        
                            R.one('account','me').get().then(
                                function(account){
                                    if($scope.add){
                                        window.location.reload();
                                        return;
                                    }
                                    $scope.submitting = false;
                                    $rootScope.user = account;
                                    $translate.use(account.language);
                                    if(account.pwdS!==null && account.pwdS!==undefined && account.pwdS<=2){
                                        $state.params.goTo = 'app.entity';
                                        $state.params.params = '{"action":"password","type":"user","filter":"'+account.id+'"}';
                                    }
                                    if(account.customRole=='TM_MANAGER'){
                                        $state.params.goTo = 'app.entity'
                                        $state.params.params = '{"action":"memories","type":"group","filter":""}'
                                    }
                                    if(account.customRole=='REVIEWER'){
                                        $state.params.goTo = 'app.entity'
                                        $state.params.params = '{"action":"list","type":"reviews","filter":""}'
                                    }
                                    if(!account.opts.gdprcheck){
                                        $state.params.goTo = 'page.privacy';
                                        //$state.params.params = '{}';
                                    }
                                    $state.go($state.params.goTo || 'app.dashboard', angular.fromJson($state.params.params));
                                    $rootScope.$broadcast('$userLoggedOn');
                                }
                            );
                            
                        })
                    } else {
                        $scope.attempts = session.attempts;
                        $scope.loginError = '';
                        $scope.submitting = false;
                        $scope.noLogin = true;
                    }
                },
                function(response){
                    $scope.attempts = -1;
                    $scope.loginError = '';
                    if(response.data && response.data.exc && response.data.exc=='InvalidValueException'){
                        if(response.data.msg.indexOf('logonAttempts=')===0){
                            $scope.loginError = 'ATTEMPTS';
                        }
                    }
                    $scope.submitting = false;
                    $scope.noLogin = true;
                }
            );

        }
    }
  }
]);
